import { Badge, type IconComponent, LuIcon, Separator } from "@overmap-ai/blocks"
import { memo } from "react"

interface TimelineIconRailProps {
	icon: IconComponent
	size: "xs" | "sm" | "md" | "lg" | "xl"
}

export const TimelineIconRail = memo<TimelineIconRailProps>((props) => {
	const { icon, size } = props

	return (
		<div className="flex shrink-0 flex-col items-center gap-2 overflow-hidden">
			<Badge size={size} accentColor="base" variant="soft" radius="full" icon>
				<LuIcon icon={icon} />
			</Badge>
			<Separator orientation="vertical" size="full" className="min-h-0 grow" />
		</div>
	)
})
TimelineIconRail.displayName = "TimelineIconRail"
